"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function goBackHistory() {
    return new Promise((resolve, reject) => {
        window.history.back();
        const callback = () => {
            resolve(null);
            window.removeEventListener("popstate", callback);
        };
        window.addEventListener("popstate", callback);
    });
}
exports.default = goBackHistory;
